import createCommonModule from '@/common/store/modules/common';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource({ rootState }) {
  return getClusterId()
    .then(clusterId => (`/api/v2/${clusterId}/iscsi-alua/connections/${rootState.routes.params.targetId}/`));
}

function plural(data) {
  return data.map(initiator => ({
    id: initiator.initiator,
    ...initiator
  }));
}

export default createCommonModule({
  resource,
  plural,
  Model: Object
});
